import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import Wizard from 'core/components/wizard'
import wizardsShape from 'core/components/wizard/shapes'
import aSteps from './steps'

const Configurator = props => {
  const { setWizards, wizards } = props //resetConfiguratorWizard
  const { aStepsConfigurator } = wizards
  const aStepsActive = wizards.aStepsConfigurator

  useEffect(() => {
    const extendedAStepsConfigurator = aSteps.map(
      item => aStepsConfigurator.filter(step => step.hash === item.hash)[0]
    )

    const extendedWizard = {
      ...wizards,
      activeWizard: 'aStepsConfigurator',
      aStepsConfigurator: extendedAStepsConfigurator
    }
    setWizards(extendedWizard)
    // resetConfiguratorWizard()
  }, [])

  return <Wizard aSteps={aSteps} aStepsActive={aStepsActive} data-test="component-configurator" />
}

Configurator.propTypes = {
  setWizards: PropTypes.func.isRequired,
  //resetConfiguratorWizard: PropTypes.func.isRequired,
  wizards: wizardsShape.isRequired
}

export default Configurator
